// Display text for the dashboard's lifetime-context columns ("Usual pace",
// "vs usual"). Display only: the grid still sorts on the raw numbers.

/** Units a month, one decimal: "0.3 a month". A small non-zero rate shows as
 *  "<0.1 a month" rather than "0.0", which would read as never selling. */
export function fmtUsualPace(n: number | null | undefined): string {
  if (n == null) return '—'
  // Net returns can exceed sales and give a negative rate; it has no usual pace.
  if (n <= 0) return '0 a month'
  if (n < 0.05) return '<0.1 a month'
  return `${n.toFixed(1)} a month`
}

/** Recent pace as a multiple of the usual pace: "3.2× usual". */
export function fmtVsUsual(n: number | null | undefined): string {
  if (n == null) return '—'
  return `${n.toFixed(1)}× usual`
}
